import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoading: false,

}

export const authSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    login: (state, action) => {
      console.log(action.payload)
      state.isLoading = action.payload
      return state;
    }
  },
})

// Action creators are generated for each case reducer function
export const { login } = authSlice.actions

export default authSlice.reducer